const translation = {
  // Navbar
  nav_hotel_intro: 'ホテル紹介',
  nav_greeting: 'ご挨拶',
  nav_about: 'ホテル紹介',
  nav_rooms: 'お部屋案内',
  nav_services: '付帯施設',
  nav_nearby: '周辺案内',
  nav_refund: '払戻し規定',
  nav_contact: 'アクセス',
  nav_support: 'サポート',
  nav_reserve: 'ご予約',

  // Hero
  hero_welcome: '韓国・東大門へようこそ',
  hero_title: 'YOUNGBIN HOTEL',
  hero_subtitle: '英賓観光ホテルへようこそ',
  hero_location: 'ソウル東大門',
  hero_cta_reserve: '今すぐ予約',
  hero_cta_rooms: 'お部屋を見る',
  hero_slide1_label: 'くつろぎの空間',
  hero_slide2_label: '居心地の良いお部屋',
  hero_slide3_label: '清潔なバスルーム',
  hero_slide4_label: '東大門の中心に位置',
  hero_slide5_label: '旅行者のための英賓ホテル',

  // About
  about_tag: '英賓ホテルへようこそ',
  about_title: '東大門の中心、\n英賓ホテル',
  about_desc1: 'ソウル特別市中区の東大門国際ファッションタウンに隣接した英賓ホテルです。東大門ショッピング街まで徒歩10分の距離にあり、ショッピングと観光を同時にお楽しみいただけます。',
  about_desc2: '快適で落ち着いたお部屋と様々な付帯施設を備え、親切なサービスで皆様の大切な旅をより特別なものにいたします。',
  about_stat1_label: 'コンシェルジュ',
  about_stat2_label: '無料Wi-Fi',
  about_stat3_label: '東大門まで徒歩',
  about_cta: 'ご予約・お問い合わせ',

  // Rooms
  rooms_tag: 'お部屋案内',
  rooms_title: 'お部屋案内',
  rooms_subtitle: '英賓ホテルの快適で居心地の良い様々なお部屋をご覧ください',
  room1_name: 'シングルルーム',
  room1_desc: '一人旅の方に最適な居心地の良い実用的なお部屋です。東大門観光の拠点として最適です。',
  room2_name: 'ツインルーム',
  room2_desc: 'シングルベッド2台のお部屋で、2名様のご旅行に最適です。広々とした快適な空間でお過ごしください。',
  room3_name: 'ダブルルーム',
  room3_desc: 'ダブルベッド1台のお部屋で、カップルや1〜2名様に最適です。居心地の良い雰囲気をご提供します。',
  room4_name: 'トリプルルーム',
  room4_desc: 'シングルベッド3台の広いお部屋で、3名様のご旅行に最適です。ご家族や小グループのご旅行に適しています。',
  room5_name: 'オンドルルーム',
  room5_desc: '韓国伝統のオンドル床暖房方式のお部屋です。温かく心地よい韓国式宿泊文化をご体験ください。',
  room6_name: 'スイートルーム',
  room6_desc: '広々とした豪華なスイートルームで、特別な旅をさらに特別なものにいたします。バスタブとミニバー完備。',

  // Services
  svc_tag: '英賓ホテルへようこそ',
  svc_title: 'サービス',
  svc_subtitle: '英賓ホテルが提供する様々なサービスをご体験ください',
  svc1_label: 'モーニングコール',
  svc1_desc: 'ご希望の時間にモーニングコールサービスを提供いたします。',
  svc2_label: '24時間コンシェルジュ',
  svc2_desc: '24時間いつでもお困りの際はご連絡ください。',
  svc3_label: 'セキュリティ',
  svc3_desc: '徹底したセキュリティシステムで安全な宿泊を保証します。',
  svc4_label: '無料Wi-Fi',
  svc4_desc: '全客室に無料高速Wi-Fiを提供しています。',
  svc5_label: 'サウナ',
  svc5_desc: '疲れを癒すサウナ施設をご利用いただけます。',
  svc6_label: '駐車場',
  svc6_desc: '便利な駐車スペースをご提供しています。',

  // Reservation
  res_tag: 'ご予約',
  res_title: 'ご予約',
  res_subtitle: '下記フォームにご記入いただければ、速やかにご連絡いたします',
  res_name: 'お名前',
  res_name_ph: '山田太郎',
  res_phone: '電話番号',
  res_phone_ph: '+82-10-0000-0000',
  res_email: 'メールアドレス',
  res_checkin: 'チェックイン日',
  res_checkout: 'チェックアウト日',
  res_room: 'お部屋タイプ',
  res_room1: 'シングルルーム',
  res_room2: 'ツインルーム',
  res_room3: 'ダブルルーム',
  res_room4: 'トリプルルーム',
  res_room5: 'オンドルルーム',
  res_room6: 'スイートルーム',
  res_message: 'お問い合わせ内容',
  res_message_ph: 'その他のお問い合わせをご入力ください。（最大500文字）',
  res_submit: '予約お問い合わせを送る',
  res_submitting: '送信中...',
  res_success_title: 'お問い合わせを受け付けました！',
  res_success_desc: '速やかにご連絡いたします。',

  // Contact
  contact_tag: '英賓ホテルへようこそ',
  contact_title: 'お問い合わせ',
  contact_address_label: '住所',
  contact_address: 'ソウル特別市中区退渓路56街18号\n（双林洞、英賓ホテル）',
  contact_phone_label: '電話 / FAX',
  contact_email_label: 'メールアドレス',
  contact_checkinout_label: 'チェックイン / チェックアウト',
  contact_checkin: 'チェックイン: 15:00',
  contact_checkout: 'チェックアウト: 12:00',

  // Footer
  footer_desc: '東大門国際ファッションタウンに隣接した英賓ホテル。\nサウナ、朝食提供、東大門ショッピング街まで徒歩10分。',
  footer_hotel_info: 'ホテル案内',
  footer_support: 'カスタマーサポート',
  footer_lang: '言語選択',
  footer_about: 'ホテル紹介',
  footer_rooms: 'お部屋案内',
  footer_services: '付帯施設',
  footer_contact: 'アクセス',
  footer_reserve: 'ご予約',
  footer_email_inquiry: 'メールお問い合わせ',
  footer_phone_inquiry: '電話お問い合わせ',
  footer_copyright: 'Copyright © 英賓ホテル. All rights reserved. | ソウル特別市中区退渓路56街18号（双林洞、英賓ホテル）',
  footer_privacy: 'プライバシーポリシー',
  footer_terms: '利用規約',
};

export default translation;
